import { useEffect, useRef, useState } from "react";
import Textarea from "react-textarea-autosize";

import {
  StyledAddAnother,
  StyledBottomSection,
  StyledContext,
  StyledContextLabel,
  StyledExample,
  StyledExamples,
  StyledExamplesLabel,
  StyledPrompt,
  StyledRandomButton,
  StyledStartersContainer,
  StyledSubBrainform,
} from "./styles";

import SVG from "react-inlinesvg";
import { MAX_BRAINSTORM_ITEM_LENGTH } from "../../../../../../src/shared/constants";

const SubBrainform = ({
  setPrompt,
  setContext,
  prompt,
  context,
  starters,
  setStarters,
  currentScreen,
  update,
  seenTips,
  setProTip,
  setShowProTip,
  width,
  showExamples,
  isInSitu,
  setEditing,
  setKeepers,
  keepers,
  promptPlaceholder,
  showRandomButton, // boolean
  randomizeExample, // function
  hasEditedStarters,
  setHasEditedStarters,
}) => {
  const [spin, setSpin] = useState(false);

  const handleDeleteStarter = (e, i) => {
    e.preventDefault();
    let newStarters = update(starters, {
      $splice: [[i, 1]],
    });
    setStarters(newStarters);
  };

  const handleAddAnother = () => {
    let newStarters = update(starters, { $push: [""] });
    setStarters(newStarters);
  };

  const handleStarterChange = (e, i) => {
    let newStarters = update(starters, {
      [i]: { $set: e.target.value },
    });
    setStarters(newStarters);
    if (!hasEditedStarters) setHasEditedStarters(true);
  };

  const handleStarterFocus = (e) => {
    e.preventDefault();
    e.target.select();
    handleShowTip(2);
  };

  const handleShowTip = (tip) => {
    if (currentScreen == 1 && seenTips.indexOf(tip) < 0) {
      setProTip(tip);
      setShowProTip(true);
    }
  };

  const firstBoxRef = useRef(null);
  useEffect(() => {
    if (firstBoxRef.current) {
      firstBoxRef.current.focus();
    }
  }, [firstBoxRef]);

  const addStartersToKeepers = () => {
    if (starters.length > 0) {
      let newKeepers = starters.filter((starter, i) => {
        //see if this starter is already in keepers
        if (starter.trim().length < 1) {
          return false;
        }
        let found = false;
        keepers.forEach((keeper) => {
          if (starter === keeper) {
            found = true;
          }
        });
        return !found;
      });

      setKeepers([...newKeepers, ...keepers]);
    }
  };

  const handleRandomSpin = () => {
    if (spin) return false;
    randomizeExample();
    setSpin(true);
    setTimeout(() => {
      setSpin(false);
    }, 300);
  };

  return (
    <StyledSubBrainform width={width}>
      <StyledPrompt
        isInSitu={isInSitu}
        className="required"
      >
        <label>Give me a list of:</label>
        <Textarea
          placeholder={promptPlaceholder || "A few words describing what you want to brainstorm "}
          value={prompt}
          maxLength={400}
          ref={firstBoxRef}
          onChange={(e) => {
            e.preventDefault();
            setPrompt(e.target.value);
          }}
          onFocus={(e) => {
            e.preventDefault();
            e.target.select();
            handleShowTip(0);
          }}
        />
        {showRandomButton && (
          <StyledRandomButton
            onClick={handleRandomSpin}
            spin={spin}
            aria-label="Randomize example"
            className="use-component-styles"
          >
            <SVG src="/assets/brainstorm/refresh-icon.svg" />
          </StyledRandomButton>
        )}
      </StyledPrompt>
      <StyledContext isInSitu={isInSitu}>
        <StyledContextLabel>Context (optional)</StyledContextLabel>
        <Textarea
          placeholder={promptPlaceholder || "Anything Sudowrite should consider, like genre, vibe, time period, setting, etc."}
          value={context}
          maxLength={400}
          onChange={(e) => {
            e.preventDefault();
            setContext(e.target.value);
          }}
          onFocus={(e) => {
            e.preventDefault();
            e.target.select();
            handleShowTip(1);
          }}
        />
      </StyledContext>
      {showExamples && !isInSitu && (
        <StyledExamples>
          <StyledExamplesLabel>Examples (optional)</StyledExamplesLabel>
          <StyledStartersContainer isInSitu={isInSitu}>
            {starters.map((item, i) => {
              return (
                <StyledExample key={`example${i}`}>
                  <Textarea
                    key={"example-bs-" + i}
                    placeholder={promptPlaceholder || "A good example"}
                    onChange={(e) => handleStarterChange(e, i)}
                    onFocus={(e) => handleStarterFocus(e)}
                    value={item}
                    maxLength={MAX_BRAINSTORM_ITEM_LENGTH}
                  />

                  {starters.length > 1 && (
                    <a
                      className="delete"
                      data-tip="Delete"
                      onClick={(e) => handleDeleteStarter(e, i)}
                    >
                      <SVG src="/assets/noun_X_2262986.svg" />
                    </a>
                  )}
                </StyledExample>
              );
            })}
          </StyledStartersContainer>
          {starters.length < 5 && (
            <StyledAddAnother
              as="button"
              type="button"
              className="use-component-styles"
              onClick={handleAddAnother}
              isInSitu={isInSitu}
            >
              <span>+</span> &nbsp;Add another
            </StyledAddAnother>
          )}
        </StyledExamples>
      )}
      <StyledBottomSection>
        {isInSitu && (
          <button
            onClick={() => {
              addStartersToKeepers();
              setEditing(false);
            }}
          >
            Done
          </button>
        )}
      </StyledBottomSection>
    </StyledSubBrainform>
  );
};

export default SubBrainform;
